import log from 'uix/logging'

const ACL_WORKSHOP = 'g:admin,g:instructor,g:participant'

export const workshop = {
  layout: 'L1Col',
  filters: [{type: 'ancestorAxisJson'}],
  enabled: ({dconfig}) => dconfig.workshop?.on,
  tabs: {
    // /workshop/list -> List all (own) workshops
    list: {
      acl: ACL_WORKSHOP,
      parts: ['WorkshopList'],
    },
    // /workshop/view/WSID -> List of topics+materials
    view: {
      acl: ACL_WORKSHOP,
      parts: ['WorkshopViewer'],
    },
    // /workshop/user/WSID -> List of all Users (Instructors, Participants)
    user: {
      acl: ACL_WORKSHOP,
      parts: ['WorkshopUser'],
    },
    graph: {
      //~ layout: 'Blank',
      acl: ACL_WORKSHOP,
      parts: [{type: 'GndoForcegraph', style: {height: '100vh', display: 'flex'}}],
    },
  },
}

export const tree = {
  tabs: {
    workshop: {
      tabGroup: 'workshop',
      tabGroupDefault: true,
      enabled: ({dconfig, tconfig}) =>
        dconfig.workshop?.on &&
        (['description_workshop', 'workshops_domain_container'].includes(tconfig.name) ||
          tconfig.datatypeName == 'workshops' ||
          tconfig.datatypeName == 'domain'),
      parts: ['WorkshopTools'],
    },
  },
}
